window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
      componentRegistry.useModulePlugin('CartAPI', {
        name: 'Integrate theme cart',
        apply(builder) {

            builder.on('methodFulfilled', 'addToCart', async (payload) => {
                fetch(`${window.location.pathname}`)
                .then((response) => response.text())
                .then((responseText) => {
                  const cartDrawerElm = document.querySelector("cart-drawer");
                  const html = new DOMParser().parseFromString(responseText, "text/html");
                  const newCartDrawerHTML = html.querySelector("#cart").innerHTML;
                  cartDrawerElm.querySelector("#cart").innerHTML = newCartDrawerHTML;
                  cartDrawerElm.classList.remove("is-empty");
                  const cart_count = html.querySelector("#cart-count").innerHTML;
                  document.querySelector("#cart-count").innerHTML = cart_count;
                  document.querySelector(".header-top__cart-btn").click();
                });
              
                return payload;
            });
        },
    });
  
  }
]);